<template>
    <div id="ag-grid-demo">
        <vs-popup title="Create new shiftdate mapping" :active.sync="showNewMappingForm">
            <v-select id="input-merchant-code" v-model="f_merchant_code" placeholder="Merchant" :options="merchants"></v-select>
            <vs-input id="input-shift-id" label="Shift ID" placeholder="Shift ID" v-model="f_shift_id"/>
            <vs-input id="input-start-time" label="Start Time" placeholder="HH:mm:ss" v-model="f_start_time"/>
            <vs-input id="input-end-time" label="End Time" placeholder="HH:mm:ss" v-model="f_end_time"/>
            <vs-input id="input-date-counted" label="Date Counted" placeholder="Date counted" v-model="f_date_counted"/>
            <div id="btn-add-container">
                <vs-button class="btn-add-mapping" id="btn-add-mapping" @click="saveMappingData()" color="primary" type="gradient">Save Mapping Data</vs-button>
            </div>
        </vs-popup>
        <vs-popup title="Edit shiftdate mapping" :active.sync="showEditMappingForm">
            <vs-input id="input-edit-merchant-name" label="Merchant" placeholder="Merchant" disabled v-model="f_edt_merchant_name"/>
            <vs-input id="input-edit-shift-id" label="Shift ID" placeholder="Shift ID" v-model="f_edt_shift_id"/>
            <vs-input id="input-edit-start-time" label="Start Time" placeholder="HH:mm:ss" v-model="f_edt_start_time"/>
            <vs-input id="input-edit-end-time" label="End Time" placeholder="HH:mm:ss" v-model="f_edt_end_time"/>
            <vs-input id="input-edit-date-counted" label="Date Counted" placeholder="Date counted" v-model="f_edt_date_counted"/>
            <div id="btn-update-container">
                <vs-button class="btn-edit-mapping" id="btn-edit-mapping" @click="updateMappingData()" color="primary" type="gradient">Update Mapping Data</vs-button>
            </div>
        </vs-popup>
        <vx-card>

            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">

                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                <vs-button id="btn-add-user" class="mb-4 md:mb-0 mr-4" icon="add" @click="openAddMappingForm()">Add Mapping</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="shiftdateMappings"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :immutableData="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="limit"
                :suppressPaginationPanel="true"
                :enableCellTextSelection="true"
            >
            </ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage"/>
        </vx-card>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import {url} from '@/configs/apiUrl'
import Axios from '@/global/AxiosCall';
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import ActionTableEditDelAgGridComponent from '@/components/cell-render-component/ActionTableEditDelAgGridComponent'
import vSelect from 'vue-select'

export default {
    components: {
        AgGridVue,
        'v-select': vSelect,
    },
    data() {
        return {
            showDropDown: false,
            f_merchant_code: "",
            f_shift_id: "",
            f_start_time: "",
            f_end_time: "",
            f_date_counted: -1,
            f_edt_id: "",
            f_edt_merchant_name: "",
            f_edt_merchant_code: "",
            f_edt_shift_id: "",
            f_edt_start_time: "",
            f_edt_end_time: "",
            f_edt_date_counted: -1,
            f_bfr_id: "",
            f_bfr_merchant_name: "",
            f_bfr_merchant_code: "",
            f_bfr_shift_id: "",
            f_bfr_start_time: "",
            f_bfr_end_time: "",
            f_bfr_date_counted: -1,
            merchants: [],
            showNewMappingForm:false,
            showEditMappingForm:false,
            activeConfirm:true,
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                resizable: true,
                suppressMenu: true
            },
            columnDefs: [
                {
                    headerName: "#",
                    field: "no",
                    width: 75,
                    pinned: "left"
                },
                {
                    headerName: "Actions",
                    field: "no",
                    cellRendererFramework: ActionTableEditDelAgGridComponent,
                    width: 110
                },
                {
                    headerName: "ID",
                    field: "id",
                    width: 80,
                },
                {
                    headerName: "Merchant Name",
                    field: "merchant_name",
                    filter: true
                },
                {
                    headerName: "Brand",
                    field: "brand",
                    filter: true
                },
                {
                    headerName: "Shift ID",
                    field: "shift_id",
                    width: 150,
                    filter: true
                },
                {
                    headerName: "Start Time",
                    field: "start_time",
                },
                {
                    headerName: "End Time",
                    field: "end_time",
                },
                {
                    headerName: "Date Counted",
                    field: "date_counted",
                    width: 200
                },
            ],
            shiftdateMappings: [],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 30,
            totalData: 1,
            activePage: 1
        }
    },
    watch: {
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.activePage = val
                this.fetchData(val, this.limit)
            }
        }
    },
    methods: {
        danger(title, text){
            this.$vs.notify({
                title: title,
                text: text,
                color: "danger",
                position: "top-right"
            });
        },
        success(title, text){
            this.$vs.notify({
                title: title,
                text: text,
                color: "success",
                position: "top-right"
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        updateMappingData(){
            this.openLoading()
            Axios.Put(url.svd.shiftdate.update + `/${this.f_edt_merchant_code}/${this.f_edt_id}`, {shift_id: this.f_edt_shift_id, date_counted: this.f_edt_date_counted, start_time: this.f_edt_start_time, end_time: this.f_edt_end_time}).then(resp => {
                this.$vs.loading.close()
                if(resp.message_code == "2002"){
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Shiftdate Mapping",
                        activity: "Edit Shiftdate Mapping",
                        data_before: {merchant_code : this.f_edt_merchant_code,shift_id: this.f_bfr_shift_id, date_counted: this.f_bfr_date_counted, start_time: this.f_bfr_start_time, end_time: this.f_bfr_end_time},
                        data_after: {merchant_code : this.f_edt_merchant_code ,shift_id: this.f_edt_shift_id, date_counted: this.f_edt_date_counted, start_time: this.f_edt_start_time, end_time: this.f_edt_end_time},
                    })
                    this.success("Success", "Shiftdate mapping updated successfully")
                    this.showEditMappingForm = false
                    this.resetDataModal()
                    this.fetchData(this.activePage, this.limit)
                } else {
                    this.danger("Error", resp.message)
                }
            }).catch(e => {
                this.$vs.loading.close()
                this.danger("Error", `Failed to update shiftdate mapping data (${typeof e != 'undefined' ? e.response.data.message : ''})`)
                console.log(e)
            })
        },
        saveMappingData(){
            this.openLoading()
            Axios.Post(url.svd.shiftdate.new, {merchant_code: this.f_merchant_code.value, shift_id: this.f_shift_id, date_counted: this.f_date_counted, start_time: this.f_start_time, end_time: this.f_end_time}).then(resp => {
                this.$vs.loading.close()
                if(resp.message_code == "2002"){
                    this.success("Success", "Shiftdate mapping saved successfully")
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Shiftdate Mapping",
                        activity: "Add Shiftdate Mapping",
                        data_before: {},
                        data_after: {merchant_code: this.f_merchant_code.value, shift_id: this.f_shift_id, date_counted: this.f_date_counted, start_time: this.f_start_time, end_time: this.f_end_time},
                    })
                    this.showNewMappingForm = false
                    this.f_merchant_code = ""
                    this.f_shift_id = ""
                    this.f_date_counted = ""
                    this.f_start_time = ""
                    this.f_end_time = ""
                    this.fetchData(1, this.limit)
                } else {
                    this.danger("Error", resp.message)
                }
            }).catch(e => {
                this.$vs.loading.close()
                this.danger("Error", `Failed to save shiftdate mapping data (${typeof e != 'undefined' ? e.response.data.message : ''})`)
                console.log(e)
            })
        },
        openAddMappingForm(){
            this.showNewMappingForm = true
            this.showDropDown = true
            this.loadMerchants()
        },
        fillDataModal(idx){
            this.f_edt_id = this.shiftdateMappings[idx].id
            this.f_edt_merchant_name = this.shiftdateMappings[idx].merchant_name
            this.f_edt_merchant_code = this.shiftdateMappings[idx].merchant_code
            this.f_edt_shift_id = this.shiftdateMappings[idx].shift_id
            this.f_edt_date_counted = this.shiftdateMappings[idx].date_counted
            this.f_edt_start_time = this.shiftdateMappings[idx].start_time
            this.f_edt_end_time = this.shiftdateMappings[idx].end_time
        },
        resetDataModal(){
            this.f_edt_id = ""
            this.f_edt_merchant_name = ""
            this.f_edt_merchant_code = ""
            this.f_edt_shift_id = ""
            this.f_edt_date_counted = ""
            this.f_edt_start_time = ""
            this.f_edt_end_time = ""
        },
        fillDataBefore(idx){
            this.f_bfr_id = this.shiftdateMappings[idx].id
            this.f_bfr_merchant_name = this.shiftdateMappings[idx].merchant_name
            this.f_bfr_merchant_code = this.shiftdateMappings[idx].merchant_code
            this.f_bfr_shift_id = this.shiftdateMappings[idx].shift_id
            this.f_bfr_date_counted = this.shiftdateMappings[idx].date_counted
            this.f_bfr_start_time = this.shiftdateMappings[idx].start_time
            this.f_bfr_end_time = this.shiftdateMappings[idx].end_time
        },
        openEditMappingForm(idx){
            this.fillDataModal(idx)
            this.fillDataBefore(idx)
            this.showEditMappingForm = true
        },
        confirmDelete(idx){
            this.fillDataModal(idx)
            this.$vs.dialog({
                type:'confirm',
                color: 'danger',
                title: `Delete data?`,
                text: `ID : ${this.shiftdateMappings[idx].id} Shift ID : ${this.shiftdateMappings[idx].id} Merchant : ${this.shiftdateMappings[idx].merchant_name}`,
                accept:()=>{this.acceptDelete(this.shiftdateMappings[idx].id, this.shiftdateMappings[idx].merchant_code)},
            })
        },
        acceptDelete(id, merchant_code){
            this.openLoading()
            Axios.Delete(url.svd.shiftdate.delete + `/${merchant_code}/${id}`).then(resp => {
                this.$vs.loading.close()
                if(resp.message_code == "2002"){
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Shiftdate Mapping",
                        activity: "Delete Shiftdate Mapping",
                        data_before: {merchant_code, shift_id: this.f_edt_shift_id, date_counted: this.f_edt_date_counted, start_time: this.f_edt_start_time, end_time: this.f_edt_end_time},
                        data_after: {},
                    })
                    this.resetDataModal()
                    this.fetchData(this.activePage, this.limit)
                    this.success("Success", "Shiftdate mapping deleted successfully")
                } else {
                    this.danger("Error", resp.message)
                }
            }).catch(e => {
                this.$vs.loading.close()
                console.log(e)
                this.danger("Error", `Failed to delete shiftdate mapping data (${typeof e != 'undefined' ? e.response.data.message : ''})`)
            })
        },
        fetchData(page, limit){
            this.openLoading()
            this.shiftdateMappings = []
            this.limit = limit
            Axios.Get(url.svd.shiftdate.list + '?page=' + page + '&limit=' + limit).then(resp => {
                this.$vs.loading.close()
                if(resp.message_code == "2002"){
                    this.shiftdateMappings = resp.data.data
                    for(let i = 0; i < this.shiftdateMappings.length;i++){
                        this.shiftdateMappings[i].no = i+1
                    }
                    this.dataCount = resp.data.total
                    this.totalPage = resp.data.lastPage
                    this.totalData = resp.data.total
                } else {
                    this.danger("Error", resp.message)
                }
            }).catch(e => {
                this.$vs.loading.close()
                console.log(e)
                this.danger("Error", `Failed to retrieve shiftdate mapping data (${typeof e != 'undefined' ? e.response.data.message : ''})`)
            })
        },
        loadMerchants(){
            Axios.Get(url.svd.merchant.combo).then(resp => {
                if(resp.code == 200){
                    this.merchants = []
                    for(let merchantobj of resp.data){
                        this.merchants.push({label: merchantobj.full_name, value: merchantobj.code})
                    }
                }
            }).catch(e => {
                console.log(e)
            })
        },
        deleteRecord(no){
            this.confirmDelete(no-1)
        },
        editRecord(no){
            this.openEditMappingForm(no-1)
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;

        this.gridOptions.getRowStyle = function(params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridOptions.rowHeight = 42;
        this.$children[0].$on('close', () => {
            this.showDropDown = false
        })

        this.$root.$on("delete-from-ActionTableEditDelAgGridComponent", (no) => {
            this.deleteRecord(no)
        })

        this.$root.$on("edit-from-ActionTableEditDelAgGridComponent", (no) => {
            this.editRecord(no)
        })
    }
}
</script>
<style scoped>
    .vs-con-input-label {width: 100%;}
    #btn-add-container, #btn-update-container {margin-top: 15px;}
</style>